import axios from 'axios';

class HttpClient {
    BASE_URL = "https://soft.pasha-life.az/hyslandingpageapi/api";

   async get (url, config){
       const res = await axios.get(`${this.BASE_URL}/${url}`, config);
       return res.data;
   }

   async post (url, data, config){
        const res = await axios.post(`${this.BASE_URL}/${url}`,data, config);
        return res;
    }
}


export const httpClient = new HttpClient();